import type { ReactNode } from 'react';
import Heading from '@alltrails/denali/components/Heading';
import FilterControlV2 from '../FilterControlV2/FilterControlV2';
import type { FilterConfigV2 } from '../FilterControlV2/types';
import styles from './FiltersModalContentV2.module.scss';

type FilterSectionV2 = {
  id: string;
  /** Optional visible section heading. Sliders/toggles carry their own labels, so their sections omit it. */
  title?: ReactNode;
  /** Optional content rendered tight beneath the title (e.g. an "About …" link) */
  titleSubtext?: ReactNode;
  /** One or more controls rendered under the heading. */
  configs: FilterConfigV2[];
};

type FiltersModalContentV2Props = {
  sections: FilterSectionV2[];
};

const FiltersModalContentV2 = ({ sections }: FiltersModalContentV2Props) => (
  <div className={styles.container}>
    {sections.map(section => (
      <div className={styles.section} key={section.id}>
        {(section.title != null || section.titleSubtext != null) && (
          <div className={styles.sectionHeader}>
            {section.title != null && (
              <Heading as="h3" size="200">
                {section.title}
              </Heading>
            )}
            {section.titleSubtext}
          </div>
        )}
        {section.configs.map(config => (
          <FilterControlV2 key={config.id} filterConfig={config} />
        ))}
      </div>
    ))}
  </div>
);

export default FiltersModalContentV2;
